<template>
  <div id="app" :class="{desktop: $store.state.isDesktop, cogir: $store.state.cogir}">

    <Header v-show="$store.state.showHeader && !$store.state.isDesktop"></Header>
    <Navigation v-if="$store.state.showHeaderLeft && $store.state.isDesktop && !$store.state.isTablet"></Navigation>

    <div class="blurContainer" :class="{blur: $store.state.showMenu, 'desktop-display': $store.state.isDesktop}">
      <Header v-show="$store.state.showHeader && $store.state.isTablet"></Header>
      <HeaderDesktop v-show="$store.state.showHeader && $store.state.isDesktop && !$store.state.isTablet"></HeaderDesktop>
      <router-view class="main"/>
      <Footer v-show="$store.state.showFooter && !$store.state.isDesktop"></Footer>
    </div>

    <Menu></Menu>

    <div id="modalConfirmation" class="modal">
      <div class="modal-content">
        <div class="modal-header"></div>
        <div class="modal-body">
          <div class="content"></div>
        </div>
        <div class="modal-footer">
          <div class="btn btn-secondary modal-no">{{ $t('no') }}</div>
          <div class="btn btn-primary modal-yes">{{ $t('yes') }}</div>
        </div>
      </div>
    </div>

    <div id="modalAffirmation" class="modal">
      <div class="modal-content">
        <div class="modal-header"></div>
        <div class="modal-body">
          <div class="content"></div>
        </div>
        <div class="modal-footer">
          <div class="btn btn-secondary modal-ok">{{ $t('ok') }}</div>
        </div>
      </div>
    </div>

    <div id="spinner">
      <template v-if="$store.state.cogir">
        <img src="@/assets/spinner-1.png" class="image-cogir-1">
        <img src="@/assets/spinner-2.png" class="image-cogir-2">
      </template>
      <template v-if="!$store.state.cogir">
        <img class="image" src="@/assets/logo.png">
        <div class="circle"></div>
      </template>
      <div id="spinnerClose" @click="closeSpinner">&times;</div>
    </div>

  </div>
</template>

<script>

  //@ts-check
  import Navigation from "@/components/desktop/Navigation.vue";
  import Footer from "./components/Footer.vue";
  import Header from "./components/mobile/Header.vue";
  import HeaderDesktop from "./components/desktop/Header.vue";
  import Menu from "./components/Menu.vue";

  import User from '../core/User';
  import Services from '../core/Services';
  import Billboard from '../core/Billboard';
  import Requests from '../core/Requests';
  import Property from '../core/Property';
  import Schedules from "../core/Schedules";
  import RequestCategories from '../core/RequestCategories';
  import Configuration from '../core/Configuration';
  import News from '../core/News';
  import moment from "moment";

  export default {

    name: "app",

    components: { Header, HeaderDesktop, Footer, Menu, Navigation },

    beforeMount() {
      this.initLocale();
      this.$store.state.cogir = CONFIG.cogir;
      this.initMetadata();
    },

    mounted() {
      if (User.token) {
        this.init();
      }
      this.resize();
    },

    data() {
      return {
        User
      };
    },

    watch: {
      "User.token": {
        handler:function(newVal) {
          this.init();
        },
        deep:true
      },
      "$store.state.isDesktop": function(newValue) {
        this.resize();
      }
    },

    methods: {
      init() {
        Services.init(!CONFIG.cogir && !this.User.token);
        Billboard.init();
        Requests.init();
        News.init();
        Property.init();
        RequestCategories.init();
        Schedules.init();
      },

      resize() {
        if (this.$store.state.isDesktop) {
          document.body.style.minHeight = "0";
          document.body.style.maxHeight = "none";
          document.body.style.height = "100%";
        } else {
          let height = window.innerHeight;
          document.body.style.minHeight = height + "px";
          document.body.style.maxHeight = height + "px";
          document.body.style.height = height + "px";
        }
      },

      initLocale() {
        this.$ts.commit("setLocale", Configuration.read("locale") || "fr");
        moment.locale(Configuration.read("locale") || "fr");
      },

      initMetadata() {
        let query = "link[rel*='icon']" + (this.$store.state.cogir ? ".humaniti" : ".cogir");
        let links = document.querySelectorAll(query);
        Array.prototype.forEach.call( links, function( node ) {
          node.parentNode.removeChild( node );
        });
        document.title = this.$store.state.cogir ? "Octopus" : "Humaniti";
      },

      closeSpinner() {
        hideSpinner();
        showAffirmation(this.$t("oops"), this.$t("errors.spinner"));
      }
    }

  }

</script>

<style lang="scss" scoped>

  #app {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #666;

    &.desktop {
      flex-direction: row;
    }
  }

  .blurContainer {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    &.blur {
      filter: blur(3px);
    }
    &.desktop-display {
      flex-direction: column;
    }
  }

  .main {
    flex-grow: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    transform: translateX(0);
  }

  #spinner {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 9999;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .circle {
      width: 160px;
      height: 160px;
      border: 4px solid rgba(255, 255, 255, 0.3);
      border-left: 4px solid white;
      animation: spin 2s linear infinite;
      transform: translate(-50%, -50%);
      position: absolute;
      left: 50%;
      top: 50%;
      border-radius: 50%;
      @keyframes spin {
        0% {transform: translate(-50%, -50%) rotateZ(0);}
        100% {transform: translate(-50%, -50%) rotateZ(360deg)}
      }
    }
    &.show {
      opacity: 1;
      pointer-events: all;
    }
    .image-cogir-1 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation: spinny 10s ease-in-out infinite;
      animation-delay: -0.02s;
      width: 200px;
      @keyframes spinny {
        0% {
          transform: translate(-50%, -50%) rotate(-30deg);
        }
        10% {
          transform: translate(-50%, -50%) rotate(30deg) scale(0.8);
        }
        20% {
          transform: translate(-50%, -50%) rotate(-30deg);
        }
        30% {
          transform: translate(-50%, -50%) rotate(30deg) scale(0.8);
        }
        40% {
          transform: translate(-50%, -50%) rotate(-30deg);
        }
        50% {
          transform: translate(-50%, -50%) rotate(30deg) scale(0.8);
        }
        60% {
          transform: translate(-50%, -50%) rotate(-30deg);
        }
        70% {
          transform: translate(-50%, -50%) rotate(30deg) scale(0.8);
        }
        80% {
          transform: translate(-50%, -50%) rotate(-30deg);
        }
        90% {
          transform: translate(-50%, -50%) rotate(30deg) scale(0.8);
        }
        100% {
          transform: translate(-50%, -50%) rotate(-390deg);
        }
      }
    }
    .image-cogir-2 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 200px;
      animation: poofy 10s ease-in-out infinite;
      @keyframes poofy {
        0% {
          transform: translate(-50%, -50%) rotate(-8deg);
        }
        10% {
          transform: translate(-50%, -50%) rotate(8deg) scale(0.8);
        }
        20% {
          transform: translate(-50%, -50%) rotate(-8deg);
        }
        30% {
          transform: translate(-50%, -50%) rotate(8deg) scale(0.8);
        }
        40% {
          transform: translate(-50%, -50%) rotate(-8deg);
        }
        50% {
          transform: translate(-50%, -50%) rotate(8deg) scale(0.8);
        }
        60% {
          transform: translate(-50%, -50%) rotate(-8deg);
        }
        70% {
          transform: translate(-50%, -50%) rotate(8deg) scale(0.8);
        }
        80% {
          transform: translate(-50%, -50%) rotate(-8deg);
        }
        90% {
          transform: translate(-50%, -50%) rotate(8deg) scale(0.8);
        }
        100% {
          transform: translate(-50%, -50%) rotate(-368deg);
        }
      }
    }
    #spinnerClose {
      position: absolute;
      top: 0;
      right: 0;
      color: white;
      opacity: 0;
      font-weight: 300;
      font-size: 40px;
      transition: opacity 1s ease;
      padding: 0 10px;
      cursor: pointer;
      line-height: 1;
      pointer-events: none;
      &.show {
        opacity: 1;
        pointer-events: all;
      }
    }
  }

</style>